import React, { lazy } from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';

const SelfSchedulingLanding = lazy(() => import('../../views/SelfSchedulingLanding/SelfSchedulingLanding'));
const PaymentResponseView = lazy(() => import('../../views/PaymentResponse/PaymentResponse'));
const AppointmentCheckout = lazy(() => import('../../views/AppoinmentCheckout/AppointmentCheckout'));

const SelfScheduling = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/:accountId/payment-response`} component={PaymentResponseView} />
      <Route exact path={`${path}/:accountId/checkout/:idService`} component={AppointmentCheckout} />
      <Route exact path={`${path}/:accountId/:professional?`} component={SelfSchedulingLanding} />
      <Redirect to="/" />
    </Switch>
  );
};

export default SelfScheduling;
